<template>
  <div class="mb-5 last:mb-0">
    <label
      class="mb-2 relative vpf-checkbox outline-none"
      tabindex="0"
      role="checkbox"
      @keyup.space="model.consent = !model.consent"
      :aria-describedby="id"
    >
      <input
        type="checkbox"
        :required="isRequired"
        @blur="handleValidation({ isBlur: true })"
        v-model="model.consent"
        @change="handleValidation()"
        @input="handleInput(!model.consent)"
        class="hidden"
      />
      <div
        class="
          vpf-checkbox__checkmark
          h-6
          w-6
          border
          absolute
          -top-px
          left-0
          flex
          items-center
          justify-center
          text-velux-red
          cursor-pointer
          z-10
        "
        :class="hasError() ? 'border-velux-red' : 'border-velux-grey-300'"
      >
        <span v-if="model.consent">
          <i class="far fa-check"></i>
        </span>
      </div>
      <div
        class="text-editor pt-0.5 md:pt-0 pl-9 text-editor text-sm md:text-base"
        :id="id"
      >
        <slot></slot>
        <span v-if="isRequired" class="text-velux-red ml-0.5">*</span>
      </div>
      <div
        v-if="hasError() && errorMessage"
        class="pl-9 text-velux-red mt-1 font-bold text-left text-base"
      >
        {{ errorMessage }}
      </div>
    </label>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
const isTicked = value => value === true;

export default {
  setup: () => ({ $v: useVuelidate() }),
  props: {
    id: String,
    errorMessage: String,
    isRequired: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      model: {
        consent: this.value,
        isTouched: false
      }
    };
  },
  mounted() {
    this.emitValidation();
  },
  methods: {
    handleValidation(isBlur) {
      this.emitValidation();
      if (!this.model.isTouched) this.model.isTouched = true;
      if (isBlur) this.$v.model.consent.$touch();
    },
    hasError() {
      return (
        this.$v.model.consent.$invalid &&
        this.model.isTouched &&
        this.isRequired
      );
    },
    handleInput(value) {
      this.$emit("input", value);
    },
    emitValidation() {
      this.$emit("inputWasChanged", this.isInvalid);
    }
  },
  computed: {
    isInvalid() {
      return this.$v.model.consent.$invalid && this.isRequired;
    }
  },
  validations: {
    model: {
      consent: {
        isTicked
      }
    }
  }
};
</script>

<style scoped>
.vpf-checkbox:focus-visible .vpf-checkbox__checkmark {
  @apply outline-none ring-2 ring-offset-2 ring-velux-blue transition-all duration-150;
}
</style>
